import axios from "axios";
import { API } from "../config/AppConfig";
import { UPLOAD_CHART, SUBMIT_UPLOADED_CHART, DELETE_CHART, COMPLAINCE_PLAN_UPLOAD_CHART, SUBMIT_COMPLAINCE_PLAN_UPLOADED_CHART, GET_COMPLAINCE_PLAN_CHART, DELETE_COMPLAINCE_PLAN_CHART, BULK_DELETE_CHART_UPLOADS, GET_CLIENT_SPECIALTIES_PROVIDERS_MAP, VALIDATE_BATCH_NAME } from "../constants/Endpoints";
import { ACCESS_TOKEN } from "../constants/PreferenceKeys";
import { whichTokenToUse } from "../utils/isManagerCreatedToken";

class UploadRepository {

  async uploadCharts(formData, onUploadProgress) {
    const token = localStorage.getItem(whichTokenToUse())
    const response = await axios.post(
      UPLOAD_CHART,
      formData,
      {
        headers: {
          Authorization: token,
        },
        onUploadProgress,
      },
    );
    // const response = await API.post(UPLOAD_CHART, {
    //   body: payload
    // });
    return response;
  }

  async submitUploadedCharts(payload) {
    const response = await API.post(SUBMIT_UPLOADED_CHART, { body: payload })
    return response;
  }
  async deleteChart(fileId) {
    const response = await API.delete(DELETE_CHART, {
      pathParams: { fileId }
    });
    return response;
  }

  async bulkDeleteChartUpload(payload) {
    const response = await API.post(BULK_DELETE_CHART_UPLOADS, {
      body: payload
    });
    return response;
  }
  
  async uploadComplaincePlanCharts(formData, onUploadProgress) {
    const token = localStorage.getItem(whichTokenToUse())
    const response = await axios.post(
      COMPLAINCE_PLAN_UPLOAD_CHART,
      formData,
      {
        headers: {
          Authorization: token,
        },
        onUploadProgress,
      },
    );
    return response;
  }

  async submitUploadedComplaincePlanCharts(formData) {
    const response = await API.post(SUBMIT_COMPLAINCE_PLAN_UPLOADED_CHART, { body: formData })
    return response;
  }

  async getUploadedComplaincePlanCharts () {
    const response = await API.get(GET_COMPLAINCE_PLAN_CHART);
    return response;
  }

  async deleteComplaincePlanCharts(fileId) {
    const response = await API.delete(DELETE_COMPLAINCE_PLAN_CHART, {
      pathParams: { fileId }
    });
    return response;
  }

  async getClientSpecialtiesProvidersMap(queryParams) {
    const response = await API.get(GET_CLIENT_SPECIALTIES_PROVIDERS_MAP, {
      queryParams
    });
    return response;
  }

  async validateBatchName(queryParams) {
    const response = await API.get(VALIDATE_BATCH_NAME, {
      queryParams
    });

    return response;
  }
}

const uploadRepository = new UploadRepository();
export default uploadRepository;